import { Button, CircularProgress, Stack, Typography, Box } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import FolderIcon from '@mui/icons-material/FolderOutlined';

import { showPicker } from '../../../utils/google2';

const noop = () => {};

export function useGoogleDrivePicker(cb) {
  return useCallback(async () => {
    const folder = await showPicker();
    return cb(folder);
  }, [cb]);
}

export default function GoogleDrivePickerButton({ onClick = noop, folder }) {
  const { t } = useTranslation();
  const onPick = useGoogleDrivePicker(onClick);

  return (
    <Stack spacing={1} width="100%">
      <Button
        variant="outlined"
        onClick={onPick}
        startIcon={<FolderIcon />}
        sx={{
          height: 40,
          justifyContent: 'flex-start',
          px: 2,
        }}
      >
        {t('Välj mapp')}
      </Button>
      {folder?.name && (
        <Box
          sx={{
            px: 2,
            py: 1,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {t('Vald mapp: {{folder}}', { folder: folder.name })}
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
